import React from 'react';

// Holds the pageProps from _app.js so deeply-nested providers (e.g. AccountProvider)
// can read server-side values (e.g. isLoggedIn) without prop-threading through every layout.
export const ServerPropsContext = React.createContext({});
